import type { ReactNode } from "react";
import { BarChart3 } from "lucide-react";
import { chart } from "@/lib/brand";

/** Shared axis styling for all Recharts charts (light theme, readable ticks). */
export const axisTick = { fill: chart.axisText, fontSize: 11 };
export const axisLabelStyle = { fill: chart.axisText, fontSize: 11 };

export function ChartHeader({ title, subtitle, aside }: { title: ReactNode; subtitle?: ReactNode; aside?: ReactNode }) {
  return (
    <div className="mb-3 flex flex-wrap items-start justify-between gap-2">
      <div className="min-w-0">
        <h3 className="font-display text-base font-semibold text-foreground">{title}</h3>
        {subtitle && <p className="mt-0.5 text-xs text-muted-foreground">{subtitle}</p>}
      </div>
      {aside && <div className="text-right text-xs text-muted-foreground">{aside}</div>}
    </div>
  );
}

export function ChartEmpty({ title }: { title: ReactNode }) {
  return (
    <div className="flex h-full w-full flex-col">
      <ChartHeader title={title} />
      <div className="flex flex-1 flex-col items-center justify-center gap-2 text-center">
        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-muted text-muted-foreground">
          <BarChart3 className="h-5 w-5" />
        </div>
        <p className="font-display text-sm font-semibold">Nog geen gegevens</p>
        <p className="text-sm text-muted-foreground">De grafiek vult zich zodra er resultaten binnenkomen.</p>
      </div>
    </div>
  );
}
